import React from "react";
import { useParams } from "react-router-dom";
import DriversProfilePage from "./DriversProfilePage.jsx";

export default function DriverProfileRoute() {
    const { driverId } = useParams();
    return <DriversProfilePage driverId={driverId} />;
}